export type ActivityCategory = 'ALL' | 'DOCUMENTS' | 'INTELLIGENCE' | 'CONVERSATIONS' | 'INVESTIGATIONS';

export interface MachineActivityItemDto {
  activity_id: string;
  occurred_at: string;
  category: string;
  event_type: string;
  title: string;
  summary: string;
  resource?: { type: string; id: string } | null;
  metadata?: Record<string, unknown>;
}

export interface MachineActivityResponseDto {
  schema_version: string;
  machine_id: string;
  activity: MachineActivityItemDto[];
  next_cursor?: string | null;
  request_id?: string;
}

export const activityFilters: Array<{ value: ActivityCategory; label: string }> = [
  { value: 'ALL', label: 'All activity' },
  { value: 'DOCUMENTS', label: 'Documents & images' },
  { value: 'INTELLIGENCE', label: 'Intelligence' },
  { value: 'CONVERSATIONS', label: 'Conversations' },
  { value: 'INVESTIGATIONS', label: 'Investigations' },
];
